import { createSelector } from 'reselect';

import Cookies from '@comeon/tomcat-cookies';

import { selectLocales } from '~/components/brand/ducks/selectors';

const DEV = process.env.NODE_ENV !== 'production';

function changeLanguage({ locale }) {
	if (Cookies.get('locale') !== locale) {
		const domain = window.location.hostname.replace('mobile.', '').replace('www', '');

		Cookies.set('locale', locale, {
			domain
		});
		Cookies.set('acceptedLocale', locale);
		Cookies.set('flagChange', true, { path: '/' });
		if (DEV) {
			window.location.pathname = '/';
		} else {
			window.location.reload();
		}
	}
}

const selectedLocale = createSelector(selectLocales, locales => {
	if (locales && locales.length > 0) {
		/**
		 * If locals array has only one item, item.checked should be true
		 * Right now data received from server it's still false
		 * adding safty net for that
		 */
		if (locales.length === 1 && !locales[0].checked) {
			return { ...locales[0], checked: true };
		}

		const selected = locales.find(locale => locale.checked);
		if (typeof selected === 'undefined') {
			// eslint-disable-next-line no-console
			console.warn('Problem retrieving locales, check LUDDE-302');
		}

		return selected || {};
	}

	return {};
});

export { selectedLocale, changeLanguage };
